export type SupportedLanguage = 'pt' | 'en' | 'es' | 'de';

export function resolveBrowserLanguage(language: string | undefined): SupportedLanguage {
  const languageCode = language?.trim().toLowerCase().split(/[-_]/)[0];
  return languageCode === 'pt' || languageCode === 'es' || languageCode === 'de' || languageCode === 'en'
    ? languageCode
    : 'en';
}
